module.exports = __webpack_public_path__ + "img/dataset.f8bc3fb6.svg";